import { createContext } from "react";

const SaContext = createContext();

export default SaContext;
